import React from 'react';
import { createMarkup } from '../../../utils';

export const P = ({ children, className, ...props }) => (
  <p className={`content ${className || ''}`} {...props} dangerouslySetInnerHTML={createMarkup(children)} />
);
